import { Observable} from "rxjs";
import { FileUploaderItem } from "../file-picker/file-picker.component";
import { IFileUploader } from "../file-picker/file-uploader.service";

export interface ModalArgs {
  title: string;
  type: ModalType;
  message: string | string[];
  /** the result of closing the dialog (default to false) */
  //result: Observable<ModalResult>;
  confirmButtonName: string;
  discardButtonName: string;

  onActionCallback: ActionCallback;

  inputs: ModalInput[];
}

export interface ModalResult {
  confirmed: boolean;
  inputsValue: { [key: string]: any };
}

export enum ModalType {
  Notification = 1,
  Alert = 2
}

export interface ModalInput {
  name: string;
  label: string;
  type: 'text' | 'multiline' | 'date' | 'file';

  value?: any | FileUploaderItem<any>;

  required?: boolean;
  maxLength?: number;
  minDate?: Date;
  maxDate?: Date;

  uploaderService?: IFileUploader;
  fileDirectoryPath?: string;
}


export type ActionCallback = (args: ModalResult) => Observable<boolean>;

///** represents the value of an input of type file, shown in modal dialog */
//export interface ModalFileValue {
//  eventSource?: FileChangedEvent;
//  initialValue?: FileUploaderItem;
//}
